export default __webpack_public_path__ + "static/media/blightedsoul.7b79bdb0.png";